<template>
  <div class="ph-special-main ">

    <div class="special-body">

      <div class="banner-container" ref="bannerContainerRef">
        <div class="banner" ref="bannerRef">
          <img  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/fed8906ffd3524329bb617f143ccfd3d.jpg" alt="">
          <p class="banner-title">让预备更智能</p>
          <img @load="onImageLoad" class="product-banner"  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260720/db847ecd960e01d4360bdb9009cd57b6.png" alt="">
        </div>
        <!--        <div>-->
        <!--          <div class="banner-logo">-->
        <!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260111/b2854b2be4cd927e35478aa0f52897b8.jpg" alt="">-->
        <!--          </div>-->
        <!--          <p class="banner-title">-->
        <!--            The Future of Endodontics-->
        <!--          </p>-->
        <!--          <div class="banner">-->
        <!--            <img @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/410fece615b99fa9e28be79c0929bd76.png" alt="">-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="preview-video-container" ref="previewVideoContainerRef">
          <!--          <div class="preview-video-box" ref="previewVideoBoxRef">-->
          <!--          </div>-->
          <div class="preview-video-text pl-100 pr-100" ref="previewVideoTextRef">
            <div class="flex">
              <p class="tit">扭矩更稳</p>
              <p class="tit ml-150">测量更准</p>
            </div>
            <div class="flex">
              <p class="tit">弯曲更易</p>
              <p class="tit ml-150">锉序列自定义</p>
            </div>
            <endo-button @onclick="openVideoModal(videoList[0].previewVideo)"></endo-button>
          </div>
          <div class="preview-video-box">
            <div class="progress">
              <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
            </div>
            <video class="background-video"
                   :ref="videoList[0].ref"
                   :src="videoList[0].video"
                   muted
                   playsinline
                   loop
                   autoplay
            ></video>
          </div>
        </div>
      </div>

      <div class="section-product-desc">
        <div class="product-logo">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/87e903851c3d897212cbc769f7cbf820.png" alt="">
        </div>
        <div class="product-logo-text">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/67e1d823677d4b4c5aff4dcee4305af0.png" alt="">
        </div>
        <div class="product-image">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251231/8bd325f95eeb52a77358086b920657f5.jpg" alt="">
        </div>
        <div class="product-special-title pl-100 pr-100">
          <div class="product-special-title-b">
            <h5>智能扭矩 预备更自如</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>
        <div class="product-detail-text1 pl-100 pr-100">
          <p class="txt">
            在连续锉模式下<br/>
            可实时分析牙本质阻力<br/>
            自动匹配根管不同区域所需扭矩<br/>
            在确保高效切削的同时<br/>
            有效降低扭转疲劳与锉断风险<br/>
          </p>
          <!--          <p class="txt">for real-time torque determination that analyzes</p>-->
          <!--          <p class="txt">the cutting resistance of files against the dentin</p>-->
          <!--          <p class="txt">wall. The Endo GT Series learns the torque needed</p>-->
          <!--          <p class="txt">to cut through dentin and automatically adjusts to</p>-->
          <!--          <p class="txt">set the ideal torque for each section of the canal.</p>-->
          <!--          <p class="txt">This ensures that cutting power is tailored to the</p>-->
          <!--          <p class="txt">task while protecting against torsional fatigue and</p>-->
          <!--          <p class="txt">file separation.</p>-->
          <endo-button @onclick="openVideoModal(videoList[1].previewVideo)"></endo-button>
        </div>

        <div class="product-video-container">
          <div class="progress">
            <circular-progress :progress="videoList[1].progress" :isPlaying="videoList[1].playing" index="1" @togglePlay="togglePlay"/>
          </div>
          <video class="product-video"
                 :ref="videoList[1].ref"
                 :src="videoList[1].video"
                 muted
                 playsinline
                 loop
                 autoplay
          ></video>
        </div>

        <div class="product-detail-text1 product-detail-text2 pl-100 pr-100">
          <p class="txt">
            马达持续监测扭矩并自动设定安全阈值<br/>
            扭矩超限时自动切换往复模式<br/>
            不同锉型无需单独设定扭矩<br/>
          </p>
        </div>

        <div class="step-list pl-100 pr-100">
          <div class="step-item video-container">
            <!--            <div class="progress">-->
            <!--              <circular-progress :progress="videoList[2].progress" :isPlaying="videoList[2].playing" index="2" @togglePlay="togglePlay"/>-->
            <!--            </div>-->
            <!--            <video class="step-video-1"-->
            <!--                   :ref="videoList[2].ref"-->
            <!--                   :src="videoList[2].video"-->
            <!--                   muted-->
            <!--                   playsinline-->
            <!--                   loop-->
            <!--                   autoplay-->
            <!--            ></video>-->
            <!--            <div class="step-video-txt">-->
            <!--              <div class="step-video-title">-->
            <!--                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">-->
            <!--                <h5>Step 1</h5>-->
            <!--              </div>-->
            <!--              <p class="txt-big mt-15">2<span class="txt-middle">s</span></p>-->
            <!--              <p class="txt-small">Learning</p>-->
            <!--              <p class="txt-small">torque</p>-->
            <!--            </div>-->
            <div class="step-image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260720/7a9f04a7b606fd98bc48aaa583c77a12.png" alt=""></img>
            </div>
          </div>
          <div class="step-item video-container">
            <!--            <div class="progress">-->
            <!--              <circular-progress :progress="videoList[3].progress" :isPlaying="videoList[3].playing" index="3" @togglePlay="togglePlay"/>-->
            <!--            </div>-->
            <!--            <video class="step-video-2"-->
            <!--                   :ref="videoList[3].ref"-->
            <!--                   :src="videoList[3].video"-->
            <!--                   muted-->
            <!--                   playsinline-->
            <!--                   loop-->
            <!--                   autoplay-->
            <!--            ></video>-->
            <!--            <div class="step-video-txt">-->
            <!--              <div class="step-video-title">-->
            <!--                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">-->
            <!--                <h5>Step 2</h5>-->
            <!--              </div>-->
            <!--              <p class="txt-small mt-25">Auto-set</p>-->
            <!--              <p class="txt-small">the ideal</p>-->
            <!--              <p class="txt-small">torque</p>-->
            <!--            </div>-->
            <div class="step-image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260720/cf75079a6b77d23a7b6ab65ed7e1f043.png" alt=""></img>
            </div>
          </div>
          <div class="step-item video-container">
            <!--            <div class="progress">-->
            <!--              <circular-progress :progress="videoList[4].progress" :isPlaying="videoList[4].playing" index="4" @togglePlay="togglePlay"/>-->
            <!--            </div>-->
            <!--            <video class="step-video-3"-->
            <!--                   :ref="videoList[4].ref"-->
            <!--                   :src="videoList[4].video"-->
            <!--                   muted-->
            <!--                   playsinline-->
            <!--                   loop-->
            <!--                   autoplay-->
            <!--            ></video>-->
            <!--            <div class="step-video-txt">-->
            <!--              <div class="step-video-title">-->
            <!--                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">-->
            <!--                <h5>Step 3</h5>-->
            <!--              </div>-->
            <!--              <p class="txt-small mt-25">Reciprocation</p>-->
            <!--              <p class="txt-small">if torque is</p>-->
            <!--              <p class="txt-small">surpassed</p>-->
            <!--            </div>-->
            <div class="step-image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260720/dff3ae1730c4ceeb5bf95ff150304e75.png" alt=""></img>
            </div>
          </div>
        </div>
      </div>

      <div class="section-product-suit section-product-desc">
        <div class="product-logo">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/fd75dc0a2eb9cc522f4458e6482640d0.png" alt="">
        </div>
        <div class="product-logo-text">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/ef9dacf873710fd3a4777acd9297cc29.png" alt="">
        </div>
        <div class="product-special-title pl-100 pr-100">
          <div class="product-special-title-b">
            <p class="tit">稳定测量 更准更清晰</p>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>

        <div class="product-detail-text1 pl-100 pr-100">
          <p class="txt">
            电子测量若不稳定<br/>
            容易造成根尖定位误差<br/>
            ClearSignal™ 技术可实时评估信号稳定性<br/>
            帮助判断连接是否可靠<br/>
            提升根尖测量的准确性<br/>
          </p>
          <!--          <p class="txt">can lead to inaccurate readings. ClearSignal™</p>-->
          <!--          <p class="txt">technology evaluates the strength of the electronic</p>-->
          <!--          <p class="txt">signal, helping determine whether the connection is</p>-->
          <!--          <p class="txt">reliable for accurately locating the foramen exit.</p>-->
          <endo-button @onclick="openVideoModal(videoList[5].previewVideo)"></endo-button>
        </div>

        <div class="g-preview-video-container product-video-container">
          <!--          <div class="progress">-->
          <!--            <circular-progress :progress="videoList[5].progress" :isPlaying="videoList[5].playing" index="5" @togglePlay="togglePlay"/>-->
          <!--          </div>-->
          <!--          <video class="g-preview-video product-video"-->
          <!--                 :ref="videoList[5].ref"-->
          <!--                 :src="videoList[5].video"-->
          <!--                 muted-->
          <!--                 playsinline-->
          <!--                 loop-->
          <!--                 autoplay-->
          <!--          ></video>-->
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/9c23d06af668398f4938108855ca1e13.jpg" alt="">
        </div>

        <div class="product-detail-text1 product-detail-text2 product-detail-text3 pl-100 pr-100">
          <p class="txt">系统可同步显示电子信号稳定性<br/>
            轻触仪表盘即可获得屏幕提示与引导</p>
        </div>

        <div class="g-mode-video-container product-video-container">
          <div class="progress">
            <circular-progress :progress="videoList[6].progress" :isPlaying="videoList[6].playing" index="6" @togglePlay="togglePlay"/>
          </div>
          <video class="g-mode-video product-video"
                 :ref="videoList[6].ref"
                 :src="videoList[6].video"
                 muted
                 playsinline
                 loop
                 autoplay
          ></video>
        </div>
      </div>

      <div class="improved-container">
        <div class="improved-banner-text pl-100 pr-100">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <p class="tit">先进弯手机控制技术</p>
            </div>
            <div class="product-special-title-p">
              <p>可精准适配多类型锉型的往复角度<br/>
                并快速切换 TorqueSense、<br/>
                ATR 等运动模式<br/>
                操作响应更迅速，也更贴合临床需求</p>
            </div>
          </div>
        </div>
        <div class="improved-banner">
          <img @load="onImprovedBanner" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260102/660f8002e2ec712d55eaceb9a66012e4.jpg" alt="">
        </div>
        <div class="improved-content pl-100 pr-100" ref="improvedContentRef">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <p class="tit">多重保护</p>
              <p class="tit">让根管预备更可控</p>
              <p class="tit">更安心</p>
            </div>
          </div>
          <div class="improved-content-detail">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <p class="tit">根尖动态预警：操作心中有数</p>
              </div>
              <div class="product-special-title-p">
                <p>声光渐进提示：锉针接近根尖时，提示音由弱渐
                  强，到达根尖LED指示灯同步闪烁提示，动态提
                  示预备深度。<br/>
                  动态轨迹监测：屏幕实时显示锉针在根管内的位
                  置趋势，让操作一目了然。</p>
              </div>
            </div>
            <div class="product-special-title">
              <div class="product-special-title-b">
                <p class="tit">智能预设控制：多种自动辅助</p>
              </div>
              <div class="product-special-title-p">
                <p>进出根管自动启停: 锉针进入根管自动运转，离开即停，简化手动操作。<br/>
                  接近根尖自动减速：临近根尖报警点自动降低转
                  速，便于医生从容操作。<br/>
                  到达根尖智能响应：到达根尖报警点时可设置自
                  动反转或自动停止，辅助医生避免过度预备。</p>
              </div>
            </div>
          </div>

          <div class="improved-button">
            <endo-button @onclick="openVideoModal(videoList[9].previewVideo)"></endo-button>
          </div>

        </div>

        <!--        <div class="improved-content" ref="improvedContentRef">-->
        <!--          <div class="torque-sense">-->
        <!--            <div class="torque-sense-logo">-->
        <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/8da99d7895634c11c0388d0b4b68907a.png" alt="">-->
        <!--            </div>-->
        <!--            <div class="product-special-title">-->
        <!--              <div class="product-special-title-b">-->
        <!--                <h5>TorqueSense</h5>-->
        <!--              </div>-->
        <!--              <div class="product-special-title-p">-->
        <!--                <p>Effortless torque</p>-->
        <!--                <p>control with precise</p>-->
        <!--                <p>adjustments</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="atr-mode">-->
        <!--            <div class="atr-mode-logo">-->
        <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/173dba0a4e426292c168e6b19dcad79b.png" alt="">-->
        <!--            </div>-->
        <!--            <div class="product-special-title">-->
        <!--              <div class="product-special-title-b">-->
        <!--                <h5>ATR Mode</h5>-->
        <!--              </div>-->
        <!--              <div class="product-special-title-p">-->
        <!--                <p>Reciprocation is ignited</p>-->
        <!--                <p>when the torque is</p>-->
        <!--                <p>surpassedas a safety feature</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div class="contra-angle-container">
        <div class="contra-angle-box">
          <div class="contra-angle-banner-text pr-100 pl-100">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <p class="tit">超薄8mm弯机头</p>
              </div>
              <div class="product-special-title-p">
                <p>轻松进入后牙区</p>
              </div>
            </div>
            <div class="bending-head">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260521/1b57ab23e7ec5043ad9a18ca38f8943c.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="contra-angle-banner-animate-box">
          <div class="contra-angle-banner">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260102/747c18d6e68bcd7e2b74f68ea0e5ddfc.jpg" alt=""/>
            <div class="contra-angle-banner-text pl-100 pr-100">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <p class="tit">LED手柄 可调冷光设计</p>
                </div>
                <div class="flex contra-angle-parameter">
                  <div class="bottom-align">
                    <div class="product-special-title-b">
                      <p class="tit" style="vertical-align: bottom;">≥8000</p>
                    </div>
                    <div class="product-special-title-p">
                      <p>lux</p>
                    </div>
                  </div>
                </div>
                <div class="product-special-title-p contra-angle-desc">
                  <p>确保视野明亮无阴影</p>
                </div>
              </div>
            </div>
            <!--          <div class="contra-angle-banner-text">-->
            <!--            <div class="product-special-title">-->
            <!--              <div class="product-special-title-b">-->
            <!--                <h5>Contra-angle</h5>-->
            <!--                <h5>head with</h5>-->
            <!--                <h5>LED light</h5>-->
            <!--              </div>-->
            <!--              <div class="flex contra-angle-parameter">-->
            <!--                <div class="bottom-align">-->
            <!--                  <div class="product-special-title-b">-->
            <!--                    <h5 style="vertical-align: bottom;">8000</h5>-->
            <!--                  </div>-->
            <!--                  <div class="product-special-title-p">-->
            <!--                    <p>lux</p>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="bottom-align">-->
            <!--                  <div class="product-special-title-b">-->
            <!--                    <h5>8 mm</h5>-->
            <!--                  </div>-->
            <!--                  <div class="product-special-title-p">-->
            <!--                    <p>diameter</p>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="product-special-title-p contra-angle-desc">-->
            <!--                <p>Ultra-slim 8 mm head for superior access</p>-->
            <!--                <p>to posterior teeth</p>-->
            <!--                <p>Adjustable cold light for shadow-free illumination</p>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
          <div class="contra-angle-animation">
            <!--          <div class="contra-angle-slider">-->
            <!--            <i class="dark">-->
            <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/791eea63527aa78c4a20687435031129.png" alt="">-->
            <!--            </i>-->
            <!--            <el-slider v-model="contraAngleSliderValue" :show-tooltip="false" :max="contraAngleBanner.length" @input="listenMove"></el-slider>-->
            <!--            <i class="light">-->
            <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/234999d86aa2515b99003560dc84cb3e.png" alt="">-->
            <!--            </i>-->
            <!--          </div>-->
            <div class="contra-angle-animation-container pl-100 pr-100">
              <img ref="contraAngleAnimationRef" :src="contraAngleBanner[0]" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="gradient-background">
        <div class="section-build-file">
          <div class="pr-100 pl-100">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <div class="flex" style="align-items: flex-end;">
                  <p class="tit">锉系统</p>
                  <p class="ml-50">Inspired by Dr. Carlos Spirinelli Ramos</p>
                </div>
                <p class="tit mt-50">全面、灵活，自由掌控</p>
              </div>
            </div>
            <div class="product-detail-text1">
              <p class="txt">内置常用锉序列，开机即可使用<br/>
                系统支持Wi-Fi软件在线升级<br/>
                锉库可随软件同步更新，始终紧跟最新标准</p>

              <p class="txt mt-77">直观界面支持自定义锉与锉序列<br/>
                可按锉号、锥度、长度等参数创建专属锉型<br/>
                也可将多品牌锉与自建锉组合为混合序列</p>

              <p class="txt mt-77">无论预备通路、MB2 或宽大复杂根管<br/>
                皆可构建独立、针对性的操作方案</p>
            </div>
          </div>

          <div class="section-product-desc">
            <div class="build-file-video-container product-video-container">
              <div class="progress">
                <circular-progress :progress="videoList[7].progress" :isPlaying="videoList[7].playing" index="7" @togglePlay="togglePlay"/>
              </div>
              <video class="build-file-video product-video"
                     :ref="videoList[7].ref"
                     :src="videoList[7].video"
                     muted
                     playsinline
                     loop
                     autoplay
              ></video>
            </div>
          </div>

        </div>

        <div class="selection-magnetic">
          <div class="product-special-title pl-100 pr-100">
            <div class="product-special-title-b">
              <p class="tit">手柄与主机无线连接</p>
            </div>
          </div>
          <div class="product-detail-text1 pl-100 pr-100">
            <p class="txt">磁吸底座轻松对接</p>
            <p class="txt mt-77">实现便捷的无接触充电</p>
          </div>
          <div class="section-product-desc">
            <div class="magnetic-video-container product-video-container ">

              <div class="progress">
                <circular-progress :progress="videoList[8].progress" :isPlaying="videoList[8].playing" index="8" @togglePlay="togglePlay"/>
              </div>
              <video class="magnetic-video product-video"
                     :ref="videoList[8].ref"
                     :src="videoList[8].video"
                     muted
                     playsinline
                     loop
                     autoplay
              ></video>
            </div>
          </div>
        </div>
      </div>




      <div class="section-touch-screen">
        <div class="touch-screen-list">
          <div class="touch-screen-item pl-100 pr-100">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <p class="tit">6 英寸高清触控屏</p>
              </div>
            </div>
            <div class="product-special-title">
              <div class="product-detail-text1">
                <p class="txt">
                  在强光下依然清晰可见<br/>
                  可戴手套流畅操作<br/>
                  快捷预设提升临床效率
                </p>
              </div>
            </div>
          </div>
          <div class="touch-screen-item">
            <div class="image pr-100 pl-100">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/f055b846712d32b00ca5269fa5fa8cef.png" alt=""/>
            </div>
            <div class="image pr-100 pl-100">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260720/b9a75b0276ccc1051581552d16098a67.png" alt=""/>
            </div>
          </div>

        </div>

        <div class="section-packaging pl-100 pr-100">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <p class="tit">可降解包装 减轻地球负担</p>
            </div>
          </div>
          <div class="product-detail-text1" >
            <p class="txt">
              我们持续减少塑料的使用。产品包装选用符合严苛环保标准的可生物降解材料，在满足产品保护与使用体验的同时，尽量降低对环境的长期影响。
            </p>

            <p class="txt mt-77">给地球的礼物，从一份会“消失”的包装开始。</p>
          </div>

          <div class="image">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260718/a91093ecc410c6cd6962a52c46537609.jpg" alt=""></img>
          </div>
        </div>

        <div class="keep-exploring pl-100 pr-100">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <p class="tit">配置</p>
            </div>
          </div>
          <div class="keep-exploring-container">
            <div class="keep-exploring-product">
              <div class="image">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>
              </div>
              <div class="desc">
                <div class="title">Endo GT Pro</div>
                <div class="info">手柄内置根测</div>
                <div class="info">主机内置根测</div>
                <div class="info">无线脚踏</div>
              </div>
            </div>

            <div class="keep-exploring-product-parameter">
              <div class="keep-exploring-product-parameter-item">
                <div class="param">6:1弯机头 * 2</div>
                <div class="param">手柄 * 1</div>
                <div class="param">主机 * 1</div>
                <div class="param">无线脚踏 * 1</div>
                <div class="param">电源适配器 * 2</div>
                <div class="param">锉夹 * 4</div>
              </div>
              <div class="keep-exploring-product-parameter-item">
                <div class="param">唇钩 * 5</div>
                <div class="param">探针 * 2</div>
                <div class="param">充电底座 * 1</div>
                <div class="param">测量线 * 1</div>
                <div class="param">测试器 * 1</div>
              </div>
              <div class="keep-exploring-product-parameter-item">
                <div class="param">注油嘴 * 1</div>
                <div class="param">一次性保护套 * 10</div>
                <div class="param">硅胶保护套 * 2</div>
                <div class="param">说明书 * 1</div>
                <div class="param">装箱单* 1</div>
              </div>
            </div>


<!--            <div class="mode-list">-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT mini</h5>-->
<!--                </div>-->
<!--                <div class="txt-card">-->
<!--                  <p class="txt txt-center">-</p>-->
<!--                  <p class="txt txt-center">-</p>-->
<!--                  <p class="txt txt-center">-</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT</h5>-->
<!--                </div>-->
<!--                <div class="txt-card pl-60">-->
<!--                  <p class="txt">手柄内置根测</p>-->
<!--                  <p class="txt pl-100">-</p>-->
<!--                  <p class="txt pl-100">-</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT Pro</h5>-->
<!--                </div>-->
<!--                <div class="txt-card pl-15">-->
<!--                  <p class="txt">手柄内置根测</p>-->
<!--                  <p class="txt">主机内置根测</p>-->
<!--                  <p class="txt">无线脚踏</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line"></i>-->

<!--            <div class="mode-function mode-list">-->
<!--              <div class="mode-function-item mode-item pl-5">-->
<!--                <p class="title">Endo GT Mini</p>-->
<!--                <p class="txt">6:1弯机头 * 2</p>-->
<!--                <p class="txt small">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4">手柄 * 1</p>-->
<!--                <p class="txt">主机 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">电源适配器 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">充电底座 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">注油嘴 * 1</p>-->
<!--                <p class="txt">一次性保护套 * 10</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">说明书 * 1</p>-->
<!--                <p class="txt">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item pl-90">-->
<!--                <p class="title">Endo GT</p>-->
<!--                <p class="txt">6:1弯机头 * 2</p>-->
<!--                <p class="txt small">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4">手柄 * 1</p>-->
<!--                <p class="txt">主机 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">电源适配器 * 1</p>-->
<!--                <p class="txt">锉夹 * 4</p>-->
<!--                <p class="txt">唇钩 * 5</p>-->
<!--                <p class="txt">探针 * 2</p>-->
<!--                <p class="txt">充电底座 * 1</p>-->
<!--                <p class="txt">测量线 * 1</p>-->
<!--                <p class="txt">测试器 * 1</p>-->
<!--                <p class="txt">注油嘴 * 1</p>-->
<!--                <p class="txt">一次性保护套 * 10</p>-->
<!--                <p class="txt">硅胶保护套 * 2</p>-->
<!--                <p class="txt">说明书 * 1</p>-->
<!--                <p class="txt">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item ml-10">-->
<!--                <p class="title">Endo GT Pro</p>-->
<!--                <p class="txt">6:1弯机头 * 2</p>-->
<!--                <p class="txt small">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4">手柄 * 1</p>-->
<!--                <p class="txt">主机 * 1</p>-->
<!--                <p class="txt">无线脚踏 * 1</p>-->
<!--                <p class="txt">电源适配器 * 2</p>-->
<!--                <p class="txt">锉夹 * 4</p>-->
<!--                <p class="txt">唇钩 * 5</p>-->
<!--                <p class="txt">探针 * 2</p>-->
<!--                <p class="txt">充电底座 * 1</p>-->
<!--                <p class="txt">测量线 * 1</p>-->
<!--                <p class="txt">测试器 * 1</p>-->
<!--                <p class="txt">注油嘴 * 1</p>-->
<!--                <p class="txt">一次性保护套 * 10</p>-->
<!--                <p class="txt">硅胶保护套 * 2</p>-->
<!--                <p class="txt">说明书 * 1</p>-->
<!--                <p class="txt">装箱单 * 1</p>-->
<!--              </div>-->
<!--            </div>-->
            <i class="line mt-114" ></i>

            <div class="specifications-container">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <p class="txt">参数</p>
                </div>
              </div>

              <div class="specifications-list ">
                <div class="specifications-item">
                  <p class="txt">转速</p>
                  <p class="title">50-3100 r/min</p>
<!--                  <p class="title ml-50">Endo GT/Endo GT mini:50-3000 r/min</p>-->
                </div>
                <div class="specifications-item">
                  <p class="txt">扭矩</p>
                  <p class="title">0.4-5.0 N·cm</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">转速比</p>
                  <p class="title">6:1</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">集成LED</p>
                  <p class="title">≥8000 lux</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">模式</p>
                  <p class="title">根测，正转，反转，往复，自适应，TorqueSense</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="section-bottom-banner">-->
      <!--        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/39eb92c8dc035af700c6690c0bdf2113.jpg" alt=""/>-->
      <!--      </div>-->

      <video-modal ref="videoModalRef"></video-modal>
    </div>
  </div>
</template>

<script>

import circularProgress from "../components/progress-circle.vue";
import endoButton from './components/button.vue'
import videoModal from '../components/video-modal.vue'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
//
export default {
  components: {
    circularProgress,
    endoButton,
    videoModal
  },
  data() {
    return {
      showHeader: true,
      is_mounted: false,
      productc_nav: false,
      videoProgress: 0,
      videoIsPlaying: true,
      contraAngleSliderValue: 0,
      valuid:1,
      videoList: [
        {
          ref: 'previewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5a9988195001834812351619254/JHyfMZyvJ4AA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/583efc7d5001834812446140858/YnZg6mSac5IA.mp4',
        },
        {
          ref: 'productVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/473fa3e65145403709194452288/1J1BHLRNKowA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/dba7465d5001834812434583427/8NtdZSaDE7QA.mp4'
        },
        {
          ref: 'stepVideo1Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
        },
        {
          ref: 'stepVideo2Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
        },
        {
          ref: 'stepVideo3Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
        },
        {
          ref: 'gPreviewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/7e22f7285145403709306548865/CUggH2zVoPcA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/afecc5db5145403727507270713/FUPyuOOaVVUA.mp4'
        },
        {
          ref: 'gModeVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/91bca19d5001834812440492971/a7SPpyyhjqAA.mp4'
        },
        {
          ref: 'buildFileVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/8492e9195001834812450735381/MnkfeBevAmcA.mp4'
        },
        {
          ref: 'magneticRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/e582aefe5001834812441767282/pXsiai2IwbwA.mp4'
        },
        {
          ref: 'improvedRef',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/668ec2795001834812208794150/aRfIS54DqV8A.mp4'
        }
      ],
      contraAngleBanner: [
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c6067e872b55e5d6acf177939ac5a0c8.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/b59ba70340db05e588244f83f18a0f8e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/493cc727e1a9b5e616f29a2211ac7104.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/9ead80eb13be4a13f0f3cdc42285c9ff.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/72ce736cd62207015f96a91f83752ce6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/649aa3dd9b0219be20c02dbb3ea41cb4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/040fbcef9345317e6d5f8b63634507eb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/8238944342b81f5b8134ce2b715286e7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6d2c31c66743625370ef787fb2ec1b27.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/de71d210ca45ff166b222da3732253a6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ab90e7a6d3975e0a29c92cf0b6a31417.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/0c819732e2b2468b7fca309e559f25d0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/16a6ce0e7b967e2f87251c7bad80659e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d280151d0cb8197d4aa42a787c454db4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ec6e696ef61b2e74fd5180921dd96b63.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/e6d25395da38d05f2d50bb58f900e4ec.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/a1956fe4da20f7f1e849500bc86a33c7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/da1db807c80ef7d3cda11b17dba77314.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/afc00c7d7b782b7d0d89a67fd164c570.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/7fb5b76f81a3d809d1228a704bc74b20.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/debef22e218b390390be149c6ff5d2a0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/cb6940cd8b4f2b756961b647d2ac8e88.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c68e77cb7327bb6b434b16d420a86eca.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6e13e064ac62342482f6871cf419acfb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/413f3dbb1a3eea85c927879f1b952ef9.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d73bc851d358422a7fa81b61e8c3e8db.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/5d117257f053179f6f41ae8d2f60dab5.jpg',
      ],
      positionNav:[
        // {
        //   title:'Home',
        //   path:'/phhome',
        // },
        // {
        //   title:'Product',
        //   path:'/phproduct',
        // },
        {
          title: 'Endo GT Series',
          path: '/ph/special/endo'
        },
      ],
      detail: {},
      value: '产品详情',
      hasUserInteraction: false,
    };
  },
  created(){

  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      this.is_mounted = true
      _this.$refs.contraAngleAnimationRef.src = _this.contraAngleBanner[_this.contraAngleBanner.length - 1]

      this.videoList.forEach((item, index) => {
        const videoRef = this.$refs[item.ref];
        if (videoRef) {
          // const videoElement = videoRef;
          //
          // // 添加各种加载事件监听
          // videoElement.addEventListener('loadeddata', (e) => {
          //   this.onVideoLoadedData(e, index);
          // });

          // videoElement.addEventListener('canplay', (e) => {
          //   this.onVideoCanPlay(e, index);
          // });
          //
          // videoElement.addEventListener('canplaythrough', (e) => {
          //   this.onVideoCanPlayThrough(e, index);
          // });
          //
          // videoElement.addEventListener('waiting', (e) => {
          //   this.onVideoWaiting(e, index);
          // });
          //
          // videoElement.addEventListener('playing', (e) => {
          //   this.onVideoPlaying(e, index);
          // });
        }
      });

      setTimeout(() => {
        _this.setupVideoIntersectionObserver()
        // _this.contraAngleAnimation()
      }, 500)
      // document.addEventListener('scroll', this.handleScroll, false)
      //
      // this.$once('hook:beforeDestroy', () => {
      //   document.removeEventListener('scroll', this.handleScroll, false)
      // })
    })
  },
  methods: {
    onVideoLoadedData(event, index){
      this.$refs[this.videoList[index].ref].play().catch(e => console.log("视频播放失败:", e));
    },
    ress(){
      var html = document.documentElement; //获取根元素
      var designWidth = 750; //设计稿宽度
      //html.clientWidth 视口宽度
      html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
    listenMove(value){
      if(value < this.contraAngleBanner.length){
        this.$refs.contraAngleAnimationRef.src = this.contraAngleBanner[value]
      }
    },
    contraAngleBannerMove(){

    },
    togglePlay(index) {
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[this.videoList[index].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
      }else {
        this.$refs[this.videoList[index].ref].pause();
      }
    },
    onImageLoad(){
      // this.initScrollAnimation();
    },
    onImprovedBanner(){
      // this.initImprovedBannerAnimation()
    },
    contraAngleAnimation(){
      const _this = this
      const totalLen = this.contraAngleBanner.length
      gsap.timeline({
        scrollTrigger: {
          trigger: ".contra-angle-banner-animate-box",
          start: `top top`,
          end: `+=500`,
          scrub: true,
          pin: true,
          onEnter: () => {
            _this.showHeader = false
          },
          onLeave: () => {

          },
          onUpdate: (self) => {
            let pic = _this.contraAngleBanner[Math.ceil(self.progress * totalLen) - 1]
            if(pic){
              _this.$refs.contraAngleAnimationRef.src = pic
            }

            if(self.progress == 1 || self.progress == 0){
              _this.showHeader = true
            }else {
              _this.showHeader = false
            }
          }
        }
      })
    },
    initImprovedBannerAnimation(){
      gsap.timeline({
        scrollTrigger: {
          trigger: ".improved-container",
          start: `top top`,
          end: `+=2000`,
          scrub: true,
          pin: true,
          onEnter: () => {
          },
        }
      }).to('.improved-banner-text', {
        opacity: 0
      })
          .to('.improved-background', {
            opacity: 1,
          }, '<')
          .to('.improved-content',{
            y: `-100vh`
          }, '<')
    },
    initScrollAnimation(){
      const _this = this

      const bannerElement = document.querySelector('.banner')

      this.videoList.forEach(item => {
        if(this.$refs[item.ref]){
          this.$refs[item.ref].addEventListener('timeupdate', this.onVideoProgress);
        }
      })
      this.setupVideoIntersectionObserver()

      gsap.timeline({
        scrollTrigger: {
          trigger: ".banner-container",
          start: `top top`,
          end: `+=4000`,
          scrub: true,
          pin: true,
          onEnter: () => {
            if (this.$refs[this.videoList[0].ref]) {
              this.$refs[this.videoList[0].ref].currentTime = 0;
              this.videoList[0].playing = true
              this.$refs[this.videoList[0].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
            }
          },
        }
      }).to(this.$refs.previewVideoContainerRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoTextRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoBoxRef, {
        background: 'rgba(0, 0, 0, 0)'
      }, "<")
    },
    setupVideoIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && !this.videoList[index].playing && this.hasUserInteraction) {
              this.$refs[this.videoList[index].ref].play().catch(() => {});
              this.videoList[index].playing = true;
            }
          }else {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].pause();
              this.$refs[this.videoList[index].ref].currentTime = 0
              this.videoList[index].playing = false;
            }
          }
        });
      }, { threshold: [0.3] });

      this.videoList.forEach(item => {
        const el = this.$refs[item.ref];
        if (el) observer.observe(el);
      });

      const handleFirstInteraction = () => {
        this.hasUserInteraction = true;
        document.removeEventListener('scroll', handleFirstInteraction);
        document.removeEventListener('touchstart', handleFirstInteraction);
      };
      document.addEventListener('scroll', handleFirstInteraction, { once: true });
      document.addEventListener('touchstart', handleFirstInteraction, { once: true });
      // const observer = new IntersectionObserver((entries) => {
      //   entries.forEach(entry => {
      //     if (entry.intersectionRatio === 0) {
      //       this.videoList.forEach(item => {
      //         if (this.$refs[item.ref] === entry.target && item.playing) {
      //           this.$refs[item.ref].pause();
      //           this.$refs[item.ref].currentTime = 0;
      //           item.playing = false;
      //         }
      //       });
      //     } else if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
      //       this.videoList.forEach(item => {
      //         if (this.$refs[item.ref] === entry.target && !item.playing) {
      //           item.playing = true;
      //           this.$refs[item.ref].play().catch(e => {
      //             item.playing = false;
      //             console.log(item.ref + "视频播放失败:", e)
      //           });
      //         }
      //       });
      //     }
      //   });
      // }, {
      //   threshold: [0, 0.1, 0.5, 1.0],
      //   rootMargin: '0px'
      // });
      //
      // this.videoList.forEach(item => {
      //   if (this.$refs[item.ref]) {
      //     observer.observe(this.$refs[item.ref]);
      //   }
      // });
      //
      // this.$once('hook:beforeDestroy', () => {
      //   this.videoList.forEach(item => {
      //     if (this.$refs[item.ref]) {
      //       observer.unobserve(this.$refs[item.ref]);
      //     }
      //   });
      // });
    },
    onVideoProgress(event) {
      const video = event.target;
      const currentTime = video.currentTime;
      const duration = video.duration;

      const videoIndex = this.videoList.findIndex(item => {
        return this.$refs[item.ref] === video;
      });

      if (videoIndex !== -1) {
        this.videoList[videoIndex].progress = ((currentTime / duration) * 100).toFixed(2);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    selesac(){
      this.valuid=this.value
      let currentRoute = this.$route;
      let query = {...currentRoute.query}
      if(this.valuid == 3){
        query.download = 1
      }else {
        delete query.download
      }
      this.$router.push({
        path: currentRoute.path,
        query: query
      }).then(() => {
        console.log('Query parameter added or updated.');
      });
    },
  },
  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
};
</script>

<style >
h1, h2, h3, h4, h5, h6, p {
  padding: 0;
  margin: 0;
}

.ph-special-main h1, .ph-special-main h2, .ph-special-main h3 {
  font-family: 'OPPOSans-H', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}

.ph-special-main h4, .ph-special-main h5 {
  font-family: 'OPPOSans-M', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
  font-weight: bold;
}
.ph-special-main p {
  font-family: 'OPPOSans-M', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}

.ph-special-main .pl-100 {
  padding-left: 100px;
}
.ph-special-main .pr-100 {
  padding-right: 100px;
}

.ph-special-main .mt-114 {
  margin-top: 114px;
}

.ph-special-main .mt-77 {
  margin-top: 77px;
}

body{
  margin: 0;
  padding: 0;
}
.phdetails{
  background: #FFF;
}
.phdeta-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 7.5rem;
  height: 0.88rem;
  background: #FFFFFF;
}
.phdetahea-left{
  font-size: 0.32rem;
  font-weight: 500;
  color: #5d5f5f;
  letter-spacing: 0.01rem;
  /*margin-left: 0.3rem;*/
}
.phdetahea-right{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  letter-spacing: 0.01rem;
}
.phdetahea-right img{
  width: 0.28rem;
  height: 0.28rem;
  margin-right: 0.3rem;
  margin-left: 0.12rem;
}

.ph-special-main{
  background: #FFF;
  padding-top: 0.88rem;
}

.ph-special-main .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb578 0%,
  #fdb578 10%,
  #f78942 70%,
  #f78942 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 65px;
  white-space: nowrap;
}

.ph-special-main .product-special-title .product-special-title-b .tit {
  font-family: 'OPPOSans-M', sans-serif;
}
.ph-special-main .product-special-title .product-special-title-b p {
  font-family: 'segoesc', sans-serif;
  color: #f45229;
  margin-top: 37px;
  font-size: 27px;
}

.ph-special-main .product-detail-text1 {
  margin-top: 127px;
}

.ph-special-main .product-detail-text1 .txt {
  color: #737070;
  letter-spacing: 1px;
  font-size: 46px;
  line-height: 1.6;
  font-weight: bold;
}

.ph-special-main .product-detail-text1 .button {
  margin-top: 164px;
}

.ph-special-main .product-detail-text2 {
  margin-top: 178px;
}

.ph-special-main .product-detail-text2 .txt {

}

.ph-special-main .product-detail-text2 .txt:first-child {
}

.ph-special-main .special-body .banner-container {
  position: relative;
  //height: 100vh;
}
.ph-special-main .special-body .banner-container .banner-logo {

}
.ph-special-main .special-body .banner-container .banner-logo img {

}
.ph-special-main .special-body .banner-container .banner {
  height: 13.5rem;
  overflow: hidden;
}

.ph-special-main .special-body .banner-container .banner img {
  width: 100%;
  display: block;
  //margin: 0 auto;
}

.ph-special-main .special-body .banner-container .banner .banner-title {
  text-align: center;
  font-size: .33rem;
  margin-top: .55rem;
}
.ph-special-main .special-body .banner-container .banner .product-banner {
  position: absolute;
  width: 2000px;
  top: 150px;
  left: 50%;
  transform: translateX(-53%);
}

.ph-special-main .special-body .preview-video-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.ph-special-main .special-body .preview-video-container .preview-video-box {
  /*width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;*/
  position: relative;
  margin-top: 62px;
}

.ph-special-main .special-body .preview-video-container .preview-video-text {
  /*position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 4;*/
}

.ph-special-main .special-body .preview-video-container .preview-video-text .tit {
  color: #666666;
  font-size: .5rem;
  padding-top: 77px;
  font-weight: bold;
}

.ph-special-main .special-body .preview-video-container .preview-video-text h4:first-child {
  //padding-top: 257px;
}

.ph-special-main .special-body .preview-video-container .preview-video-text .button {
  /*margin: 144px auto 0 auto;*/
  margin-top: 225px;
}
.ph-special-main .special-body .video-container .progress,
.ph-special-main .special-body .preview-video-container .progress {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 5;
}

.ph-special-main .special-body .preview-video-container .background-video {
  /*position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
  z-index: 1;*/
  width: 100%;
  display: block;
}


.ph-special-main .special-body .section-product-desc {
  padding: 80px 0 0 0;
}

.ph-special-main .special-body .section-product-desc .product-logo {
  margin: 110px auto 0 auto;
  width: 280px;
}

.ph-special-main .special-body .section-product-desc .product-logo-text {
  margin: 71px auto 0 auto;
  width: 660px;
}

.ph-special-main .special-body .section-product-desc .product-image {
  margin-bottom: 180px;
  width: 100%;
}

.ph-special-main .special-body .section-product-desc .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ed5a10 50%,
  #ed5a10 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .6rem;
  font-weight: 700;
  letter-spacing: -2px;
}

.ph-special-main .special-body .section-product-desc .product-special-title .product-special-title-b p {
  font-size: .26rem;
  margin-top: 20px;
}
.ph-special-main .section-product-desc .product-detail-text1 {
  margin-top: .8rem;
  padding-bottom: .45rem;
}

.ph-special-main .section-product-desc .product-detail-text1 .txt {
  font-size: .29rem;
  line-height: 1.8;
}

.ph-special-main .special-body .section-product-desc .product-detail-text2 {
  background-color: #f9f9fa;
  margin-top: 0;
  padding-top: 150px;
  padding-bottom: 45px!important;
}
.ph-special-main .section-product-desc .product-detail-text2 .txt {
  line-height: 4;
}
.ph-special-main .special-body .section-product-desc .step-list {
  padding-top: 90px;
  background-color: #f9f9fa;
  padding-bottom: 160px;
}

.ph-special-main .special-body .section-product-desc .step-list .step-item {
  width: 6.5rem;
  position: relative;
  overflow: hidden;
  border-radius: 30px;
  margin-top: 24px;
}

.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt {
  position: absolute;
  left: 98px;
  top: 50%;
  transform: translateY(-50%);
}
.txt-big {}

.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title {
  display: flex;
  position: relative;
  width: 150px;
}
.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title h5,
.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title img {
  display: block;
  width: 100%;
}

.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title h5 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  font-size: 28px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
}

.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-big {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 30%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 80px;
  font-weight: bold;
  margin-left: 10px;
}
.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-middle {
  font-size: 70px;
}
.ph-special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-small{
  font-size: 30px;
  font-weight: bold;
}

.ph-special-main .special-body .section-product-desc .step-list .step-item:first-child {
  margin-top: 0;
}

.ph-special-main .special-body .section-product-desc .step-list .step-item video {
  width: 100%;
  display: block;
  scale: 1.1;
}

.ph-special-main .special-body .section-product-desc .product-video-container {
  position: relative;
  width: 100%;
}

.ph-special-main .special-body .section-product-desc .product-video-container .product-video {
  width: 100%;
  display: block;
}

.ph-special-main .special-body .section-product-desc .product-video-container .progress {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 5;
}

.ph-special-main .special-body .section-product-desc img {
  display: block;
  width: 100%;
}

.ph-special-main .special-body .section-product-suit {
  background: #ffffff;
}

.ph-special-main .special-body .section-product-suit .product-logo {
  width: 700px;
}

.ph-special-main .special-body .section-product-suit .product-logo-text {
  width: 750px;
  margin-top: -60px;
}

.ph-special-main .special-body .section-product-suit .product-special-title {
  margin-top: 162px;
}

.ph-special-main .special-body .section-product-suit .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #eb550c 55%,
  #eb550c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .56rem;
  font-weight: bold;
}

.ph-special-main .special-body .section-product-suit .product-special-title .product-special-title-b p {
  margin-top: 10px;
}

.ph-special-main .special-body .section-product-suit .g-preview-video-container {
}

.ph-special-main .special-body .section-product-suit .product-detail-text1 {
  margin-top: 60px;
  padding-bottom: 130px;
}

.ph-special-main .special-body .section-product-suit .product-detail-text1 .txt {
  margin-top: 10px;
}

.ph-special-main .special-body .section-product-suit .product-detail-text1 .txt:first-child {
  margin-top: 0;
}
.ph-special-main .special-body .section-product-suit .product-detail-text1 .button {
  margin-top: 125px;
}
.ph-special-main .special-body .section-product-suit .product-detail-text2 {
  margin-top: 0px;
  background-color: #ffffff;
  padding-bottom: 50px;
}

.ph-special-main .special-body .section-product-suit .product-detail-text3 {
  margin-top: 60px;
  background-color: #ffffff;
  padding-bottom: 120px!important;
}
.ph-special-main .special-body .section-product-suit .product-detail-text3 .txt {
  line-height: 1.6;
}
.ph-special-main .special-body .section-product-suit .g-mode-video-container {
  width: 100%;
  padding-bottom: 300px;
}

.ph-special-main .special-body .improved-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.ph-special-main .special-body .improved-container .improved-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}


.ph-special-main .special-body .improved-container .improved-banner .improved-background {
  position: absolute;
  width: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  backdrop-filter: blur(20px) brightness(60%);
  opacity: 0;
  pointer-events: none
}

.ph-special-main .special-body .improved-container .improved-banner-text {
  background-color: #000000;
  padding-top: 214px;
  padding-bottom: 135px;
}

.ph-special-main .special-body .improved-container .improved-banner-text .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ef5c11 40%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  text-align: left;
  font-size: .56rem;
  font-weight: bold;
}

.ph-special-main .special-body .improved-container .improved-banner-text .product-special-title .product-special-title-p {
  margin-top: 70px;
}

.ph-special-main .special-body .improved-container .improved-banner-text .product-special-title .product-special-title-p p {
  font-weight: bold!important;
  font-size: 58px;
  line-height: 1.8;
  color: #cccccc;
}

.ph-special-main .special-body .improved-container .improved-banner img {
  width: 100%;
  display: block;
}

.ph-special-main .special-body .improved-container .improved-content {
  background-color: #000000;
  padding-top: 170px;
  padding-bottom: 80px;
}

.ph-special-main .special-body .improved-container .improved-content .product-special-title {

}

.ph-special-main .special-body .improved-container .improved-content .product-special-title .product-special-title-b .tit {
  font-size: .5rem;
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-weight: bold;
  line-height: 1.4;
  margin-top: 0;
}

.ph-special-main .special-body .improved-container .improved-content .product-special-title  .product-special-title-p {
  margin-top: 60px;
}
.ph-special-main .special-body .improved-container .improved-content .product-special-title  .product-special-title-p p {
  color: #ffffff;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 1.8;
}
.ph-special-main .special-body .improved-container .improved-content img {
  display: block;
  width: 100%;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail {}
.ph-special-main .special-body .improved-container .improved-content .improved-button {
  margin-top: 114px;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title {
  margin-top: 40px;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title:nth-child(2) {
  margin-top: 18px;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title  .product-special-title-b .tit{
  font-size: .29rem;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title:nth-child(2) .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ef5c11 25%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title  .product-special-title-p {
  margin-top: 0px;
}
.ph-special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title  .product-special-title-p p{
  font-size: .29rem;
  color: #bfcfd2;
  font-weight: 500;
  line-height: 1.6;
}


.ph-special-main .special-body .improved-container .improved-content .torque-sense {
  margin-top: 212px;
  padding-right: 183px;
}

.ph-special-main .special-body .improved-container .improved-content .torque-sense .torque-sense-logo,
.ph-special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {
  width: 143px;
}

.ph-special-main .special-body .improved-container .improved-content .torque-sense .torque-sense-logo {
  margin: 0 auto;
}
.ph-special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {
  margin-left: 20px;
}

.ph-special-main .special-body .improved-container .improved-content .atr-mode {
  margin-top: 212px;
  padding-left: 183px;
}
.ph-special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {

}


.ph-special-main .special-body .contra-angle-container {
  background-color: #000000;
  padding-bottom: 190px;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text {
  position: relative;
  z-index: 1;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .bending-head {
  position: absolute;
  width: 1.3rem;
  top: 2.3rem;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .bending-head img {
  display: block;
  width: 100%;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .product-special-title .product-special-title-b{
  display: flex;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .product-special-title .product-special-title-b .tit{
  font-size: .6rem;
  font-weight: bold;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
/*.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .product-special-title .product-special-title-b h5:nth-child(2){
  margin-left: 20px;
  color: #b1b1b1;
}*/
.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .product-special-title .product-special-title-p {
  margin-top: 20px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-box .contra-angle-banner-text .product-special-title .product-special-title-p p{
  font-size: .315rem;
  font-weight: bold;
  color: #cccccc;
  line-height: 1.8;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner {
  position: relative;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner  .contra-angle-banner-animate-box {
  height: 100vh;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner img {
  display: block;
  width: 100%;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text {
  margin-top: 180px;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ed5408 60%,
  #ed5408 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .58rem;
  font-weight: bold;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .product-special-title-b h5:nth-child(2){
  margin-top: 10px;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter {
  margin-top: 84px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align:nth-child(2) {
  margin-left: 68px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 80%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .34rem;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p {
  margin-left: 7px;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p,
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p p {
  color: #b2b2b2;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p p {
  font-size: .2rem;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p{
  font-size: .3rem;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc {
  margin-top: 90px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p{
  margin-top: 14px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p:first-child {
  margin-top: 0;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-animation {
  background-color: #000000;
  padding-top: 178px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider .el-slider {
  width: 300px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider i {
  display: block;
  width: 50px;
}

.ph-special-main .special-body .contra-angle-container .contra-angle-slider .dark {
  margin-right: 19px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider .light {
  margin-left: 19px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider i img {
  display: block;
  width: 100%;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider .el-slider__bar,
.ph-special-main .special-body .contra-angle-container .contra-angle-slider .el-slider__runway {
  height: 12px;
  border-radius:50px;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider .el-slider__bar {
  background-color: #6c5dd3;
}
.ph-special-main .special-body .contra-angle-container .contra-angle-slider .el-slider__button {
  position: absolute;
  top:50%;
  left: 50%;
  margin-top: -13px;
  margin-left: -13px;
  background-color: #6c5dd3;
  border: 0;
  width: 30px;
  height: 30px;
}
.ph-special-main .special-body .contra-angle-animation .contra-angle-animation-container {

}
.ph-special-main .special-body .contra-angle-animation .contra-angle-animation-container img {
  display: block;
  width: 100%;
}


.ph-special-main .special-body .section-build-file {
  padding-top: 160px;
}
.ph-special-main .special-body .section-build-file .product-detail-text1 {
  margin-top: 95px;
}
.ph-special-main .special-body .section-build-file .build-file-video-container {

}
.ph-special-main .special-body .section-build-file .product-special-title {}
.ph-special-main .special-body .section-build-file .product-special-title .product-special-title-b {}

.ph-special-main .special-body .section-build-file .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #eb540a 50%,
  #eb540a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .56rem;
  font-weight: bold;
}
.ph-special-main .special-body .section-build-file .product-special-title .product-special-title-b .flex .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fa9653 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.ph-special-main .special-body .section-build-file .build-file-video-container {}
.ph-special-main .special-body .section-build-file .build-file-video-container .build-file-video {
  display: block;
  width: 100%;
}

.ph-special-main .special-body .section-build-file .product-special-title .product-special-title-b p {
  font-size: .21rem;
  color: #ff6241;
  margin-top: 0px;
}
.ph-special-main .special-body .section-build-file .product-detail-text1 .txt {
  letter-spacing: 0;
}
.ph-special-main .special-body .selection-magnetic {
  background: linear-gradient(#fefefe 0%, #f5f5f7 50%, #f5f5f7 100%);
  padding-top: 220px;
  padding-bottom: 160px;
}

.ph-special-main .special-body .selection-magnetic .product-detail-text1 {
  margin-top: 100px;
}
.ph-special-main .special-body .selection-magnetic .product-detail-text1 .txt {
  font-size: .29rem;
}
.ph-special-main .special-body .selection-magnetic .magnetic-video {
  display: block;
  width: 100%;
  scale: 1.1;
}

.ph-special-main .special-body .selection-magnetic .section-product-desc {
  padding: 0!important;
}

.ph-special-main .special-body .selection-magnetic .section-product-desc .magnetic-video-container {
  margin: 148px auto 0 auto !important;
  width: 6.5rem!important;
  overflow: hidden;
  border-radius: 30px;
}




.ph-special-main .special-body .selection-magnetic .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 60%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .54rem;
  font-weight: bold;
}


.ph-special-main .special-body .section-touch-screen {
  background: linear-gradient(#fefefe 0%, #f5f5f7 50%, #f5f5f7 100%);
  padding-top: 150px;
  padding-bottom: 186px;
}
.ph-special-main .special-body .section-touch-screen .touch-screen-list {

}
.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item:nth-child(even) {

}

.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-special-title {
  padding-bottom: 108px;

}
.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-special-title:nth-child(2) {
  padding-bottom: 200px;
}

.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-special-title .product-detail-text1 {
  margin: 0;
  padding: 0;
}

.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-special-title .product-detail-text1 .txt {
  font-size: .29rem;
}

.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-special-title .product-special-title-b {

}
.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-special-title-b .tit{
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ef5c11 35%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .55rem;
  font-weight: bold;
}
.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .product-detail-text1 {

}
.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .image:nth-child(2) {
  margin-top: 69px;
}
.ph-special-main .special-body .section-touch-screen .touch-screen-list .touch-screen-item .image img {
  display: block;
  width: 100%;
}


.ph-special-main .section-packaging {
  margin-top: 175px;
}

.ph-special-main .section-packaging .product-special-title .product-special-title-b .tit {
  color: transparent;
  background: linear-gradient(to right,
  #00f342 0%,
  #00dd00 20%,
  #00d100 55%,
  #00c000 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .57rem;
  font-weight: bold;
  text-align: center;
}

.ph-special-main .section-packaging .product-detail-text1 {
  margin-top: 90px;
}
.ph-special-main .section-packaging .product-detail-text1 .txt {
  font-size: .27rem;
  font-weight: bold;
}
.ph-special-main .section-packaging .product-detail-text1 .txt:nth-child(6) {
  //margin-top: 30px;
  margin-top: .34rem;
}
.ph-special-main .section-packaging .image {
  width: 100%;
  margin: 90px auto 0 auto;
}
.ph-special-main .section-packaging .image img {
  display: block;
  width: 100%;
  border-radius: 30px;
}

.ph-special-main .special-body .section-touch-screen .keep-exploring {
  margin-top: 264px;
}
.ph-special-main .section-touch-screen .keep-exploring .product-special-title-b .tit {

  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 0.5%,
  #ef5c11 5%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: .28rem;
  font-weight: bold;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container {
  margin-top: .5rem;
}

.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product {
  display: flex;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .image {
  width: 1.6rem;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .image img {
  display: block;
  width: 100%;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .desc {
  margin-left: 1.1rem;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .desc .title {
  font-size: .3rem;
  font-weight: 500;
  margin-top: .55rem;
  color: #333333;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .desc .info {
  font-size: .2rem;
  color: #666666;
  margin-top: .18rem;
}

.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter{
  display: flex;
  margin-top: .6rem;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item{
  margin-left: .7rem;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item:first-child{
  margin-left: 0;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item:last-child{
  margin-left: 0;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item .param {
  font-size: .23rem;
  width: 2rem;
  margin-top: .1rem;
  color: #333333;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item .param:first-child{
  margin-top: 0;
}


.ph-special-main .special-body .section-touch-screen .keep-exploring .keep-exploring-container .line {
  display: block;
  border-top: #e7e7e9 1px solid;
  width: 100%;
  margin-top: 94px;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .product-special-title .product-special-title-b h5 {
  text-align: left;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list {
  display: flex;
  justify-content: center;

}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item {
  flex: 1;
  margin-left: 50px;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .mode-item-box {
  padding-right: 45px;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item:first-child {
  margin-left: 0;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .image {

}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .image img {
  display: block;
  width: 240px;
  margin: 0 auto;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item {

}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .title {
  font-size: 45px;
  margin-top: 71px;
  color: #0f0f0f;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .txt-card {

}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .txt {
  font-size: .18rem;
  margin-top: 23px;
  color: #707070;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-list .mode-item .txt:nth-child(2) {
}

.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-function {}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-function .mode-function-item {}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-function .mode-function-item .title {
  font-size: 36px;
  margin-top: 120px;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-function .mode-function-item .txt {
  color: #383a4a;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .mode-function .mode-function-item .small {
  font-size: 20px;
}

.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container {
  margin-top: 90px;
  padding-left: 5px;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .product-special-title {}
.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .product-special-title .product-special-title-b {}
.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .product-special-title .product-special-title-b .txt {
  font-size: .28rem;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 0.5%,
  #ef5c11 5%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-weight: bold;
}

/*.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .specifications-list {}
.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item {
  margin-top: 53px;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .title {
  font-size: 30px;
  color: #333333;
  margin-top: 0;
  line-height: 1.6;
}
.ph-special-main .special-body .section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .txt {
  color: #796e72;
  font-size: 27px;
  margin-top: 15px;
}*/

.ph-special-main .section-touch-screen .keep-exploring .specifications-container .specifications-list {}
.ph-special-main .section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item {
  margin-top: 50px;
  display: flex;
}
.ph-special-main .section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .title {
  font-size: .16rem;
  color: #131313;
  margin-top: 0;
  line-height: 1.6;
}
.ph-special-main .section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .txt {
  color: #6f6f74;
  font-size: .18rem;
  line-height: 1.6;
  width: 200px;
}

.ph-special-main .special-body .section-bottom-banner {
}
.ph-special-main .special-body .section-bottom-banner img {
  display: block;
  width: 100%;
}
</style>
